import React from 'react';

export default function VideoBlockConfig({ data, onChange }) {
  const update = (field, value) => onChange({ ...data, [field]: value });

  return (
    <>
      <div className="adminblog-field">
        <label>Video Type</label>
        <select value={data.type || 'YouTube'} onChange={(e) => update('type', e.target.value)}>
          <option value="YouTube">YouTube</option>
          <option value="Vimeo">Vimeo</option>
          <option value="Local">Local file</option>
        </select>
      </div>
      <div className="adminblog-field">
        <label>Video URL</label>
        <input type="text" value={data.url || ''} onChange={(e) => update('url', e.target.value)} placeholder="YouTube, Vimeo, or MP4 URL" />
      </div>
      <div className="adminblog-field">
        <label>Thumbnail URL</label>
        <input type="text" value={data.thumbnail || ''} onChange={(e) => update('thumbnail', e.target.value)} placeholder="Thumbnail image URL" />
        {data.thumbnail && <img src={data.thumbnail} alt="Thumb" style={{ width: '100%', borderRadius: 6, marginTop: 8, aspectRatio: '16/9', objectFit: 'cover' }} />}
      </div>
      <div className="adminblog-field">
        <label>Caption</label>
        <input type="text" value={data.caption || ''} onChange={(e) => update('caption', e.target.value)} placeholder="Video caption" />
      </div>
      <div className="adminblog-field">
        <label>
          <input type="checkbox" checked={data.autoplay || false} onChange={(e) => update('autoplay', e.target.checked)} style={{ marginRight: 8 }} />
          Autoplay
        </label>
      </div>
    </>
  );
}
